import Vue from 'vue'
import {
    Input,
    Radio,
    Checkbox,
    Select,
    Option,
    Button,
    DatePicker,
    Row,
    Col,
    Image,
    MessageBox,
    Carousel,
    CarouselItem,
    Dialog
} from 'element-ui';

import '../element-variables.scss'
import 'element-ui/lib/theme-chalk/display.css';
import lang from 'element-ui/lib/locale/lang/de'
import locale from 'element-ui/lib/locale'
locale.use(lang)

Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$ELEMENT = {
    size: 'small'
};

Vue.use(Input);
Vue.use(Radio);
Vue.use(Checkbox);
Vue.use(Select);
Vue.use(Option);
Vue.use(Button);
Vue.use(DatePicker);
Vue.use(Row);
Vue.use(Col);
Vue.use(Image);
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Dialog);